<template>
  <Form ref="form" @submit.prevent="submit">
    <ZDialog :show="isVisible">
      <template #header>
        <div>
          <h4 class="modal-title">
            Phone
          </h4>
        </div>
      </template>
      <template #body>
        <div>
          <ContactSummary class="mb-4" :contact="value" />
          <div class="form-control custom-form">
            <ZSelect v-model="phoneType" :value="phoneType" label="Phone Type" name="phoneType"
              :options="lookups['PhoneType']" validate="required" />
            <label for="PhoneNo">Phone #:</label>
            <span class="text-danger">*</span>
            <MaskInput class="form-control mb-3" name="PhoneNo" mask="(###) ###-####" v-model="phoneNo" :value="phoneNo"
              validate="required" placeholder="(___) ___-____" />
            <span v-if="roError" class="text-danger">{{ roError }}</span>
            <ZInput v-model="extension" :value="extension" name="Extension" label="Extension" type="Number" />
            <ZTextArea v-model="phoneNote" :value="phoneNote" name="PhoneNote" label="Notes" />
          </div>
        </div>
      </template>
      <template #footer>
        <div>
          <button type="button" class="btn btn-light" @click="close()">Cancel</button>
          <button type="submit" class="btn btn-primary ms-1" @click="save()">Save</button>
        </div>
      </template>
    </ZDialog>
  </Form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookups, contacts } from '@/stores'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZTextArea from '@/components/utilities/elements/TextArea.vue'
import ContactSummary from '@/components/contacts/forms/contact-summary.vue'
import { Form } from 'vee-validate'
import { MaskInput } from 'vue-3-mask'
export default {
  name: 'contact-phone',
  components: {
    ZDialog,
    ZSelect,
    ZInput,
    ZTextArea,
    ContactSummary,
    Form,
    MaskInput
  },
  props: {
    value: {
      type: Object
    },
    phone: {
      type: Object,
      default() {
        return {
          contactPhone: 0,
          extension: '',
          isShared: false,
          phone: 0,
          phoneNo: '',
          phoneNote: '',
          phoneType: 0,
          phoneTypeName: '',
          primary: ''
        }
      }
    }
  },
  computed: {
    ...mapState(lookups, ['lookups']),
    phoneType: {
      get() {
        return this.phone !== null ? this.phone.phoneType : 0
      },
      set(value) {
        this.setItem({
          type: 'Phone',
          id: this.phone.contactPhone,
          property: 'phoneType',
          value: parseInt(value)
        })
      }
    },
    phoneNo: {
      get() {
        return this.phone !== null ? this.phone.phoneNo : ''
      },
      set(value) {
        if (!this.phone || this.phone.contactPhone == null) return;
        this.roError = '';
        this.setItem({
          type: 'Phone',
          id: this.phone.contactPhone,
          property: 'phoneNo',
          value: value
        });
      }
    },
    extension: {
      get() {
        return this.phone !== null ? this.phone.extension : ''
      },
      set(value) {
        this.setItem({
          type: 'Phone',
          id: this.phone.contactPhone,
          property: 'extension',
          value: value
        })
      }
    },
    phoneNote: {
      get() {
        return this.phone !== null ? this.phone.phoneNote : ''
      },
      set(value) {
        this.setItem({
          type: 'Phone',
          id: this.phone.contactPhone,
          property: 'phoneNote',
          value: value
        })
      }
    },
    isVisible: {
      get() {
        return this.value !== null
      }
    }
  },
  methods: {
    ...mapActions(contacts, ['setItem', 'removePhone']),
    close() {
      if (this.phone.contactPhone === -1) {
        this.removePhone(-1)
      }
      this.$emit('closing')
    },
    async save() {
      if (!this.phoneNo || this.phoneNo.trim() === '') {
        this.roError = 'This field is required';
        return;
      }
      this.roError = '';
      this.$refs.form.validate().then(async success => {
        if (success.valid) {
          this.$emit('send', this.phone.contactPhone)
        }
      })
    },
    handleInput(event) {
      let input = event.target.value.replace(/\D/g, '').slice(0, 10);
      this.phoneNo = input.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    },
    submit() { }
  }
}
</script>
<style lang="scss" scoped>
.custom-form {
  text-align: left;
  max-height: 250px;
  height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
